import React, { useState, useEffect } from 'react'
import { Container } from './styles'
import ScrollAnimation from 'react-animate-on-scroll'

// --- FUNGSI FALLBACK BARU (UNTUK HTTP) ---
/**
 * Salin ke clipboard menggunakan metode document.execCommand (fallback).
 */
const fallbackCopyToClipboard = (text: string) => {
  const textArea = document.createElement('textarea')
  textArea.value = text
  
  // Mencegah scroll saat menempel elemen
  textArea.style.top = "0"
  textArea.style.left = "0"
  textArea.style.position = "fixed"

  document.body.appendChild(textArea)
  textArea.focus()
  textArea.select()

  try {
    document.execCommand('copy')
    return Promise.resolve(true) // Kembalikan promise agar konsisten
  } catch (err) {
    console.error('Fallback: Gagal menyalin', err)
    return Promise.reject(err)
  } finally {
    document.body.removeChild(textArea)
  }
}

/**
 * Helper copy-to-clipboard yang aman, berfungsi di HTTPS dan HTTP.
 */
const copyToClipboard = (text: string) => {
  if (!navigator.clipboard) {
    // Jika navigator.clipboard tidak ada (di HTTP), gunakan fallback
    return fallbackCopyToClipboard(text)
  }
  // Jika ada (di HTTPS/localhost), gunakan metode modern
  return navigator.clipboard.writeText(text)
}
// --- AKHIR FUNGSI BARU ---


// Interface ServerData tetap sama
interface ServerData {
  online: boolean
  icon?: string
  motd?: {
    html: string
  }
  version?: {
    name_clean: string
  }
  players?: {
    online: number
    max: number
  }
}

export function ServerStatus() {
  const [serverData, setServerData] = useState<ServerData | null>(null)
  const [loading, setLoading] = useState(true)
  
  const [javaCopied, setJavaCopied] = useState(false)
  const [bedrockCopied, setBedrockCopied] = useState(false)

  const javaIp = 'barul.my.id'
  const bedrockIp = 'bedrock.barul.my.id:5434'
  const dynmapUrl = 'https://map.barul.my.id/'
  const installerUrl = 'https://github.com/Baruls/LegacyCraft-Installation/releases'
  const tutorialUrl = 'https://github.com/Baruls/LegacyCraft-Installation'

  useEffect(() => {
    fetch(`https://api.mcstatus.io/v2/status/java/${javaIp}`)
      .then((response) => response.json())
      .then((data) => {
        setServerData(data)
        setLoading(false)
      })
      .catch((error) => {
        console.error('Error fetching server status:', error)
        setServerData({ online: false })
        setLoading(false)
      })
  }, [])

  // --- PERBARUI FUNGSI INI ---
  const copyJavaToClipboard = () => {
    copyToClipboard(javaIp).then(() => { // <-- Gunakan helper baru
      setJavaCopied(true)
      setTimeout(() => setJavaCopied(false), 2000)
    })
  }

  // --- PERBARUI FUNGSI INI ---
  const copyBedrockToClipboard = () => {
    copyToClipboard(bedrockIp).then(() => { // <-- Gunakan helper baru
      setBedrockCopied(true)
      setTimeout(() => setBedrockCopied(false), 2000)
    })
  }

  const renderMotd = () => {
    if (!serverData?.motd?.html) return null
    return (
      <div
        className="motd"
        dangerouslySetInnerHTML={{ __html: serverData.motd.html }}
      />
    )
  }

  // ... sisa kode return Anda (tidak perlu diubah) ...
  return (
    <Container>
      <ScrollAnimation animateIn="fadeInUp" delay={0.1 * 1000}>
        <h2>Server Status</h2>
      </ScrollAnimation>
      
      <ScrollAnimation animateIn="fadeInUp" delay={0.2 * 1000}>
        <p>Status of our Barul Minecraft server.</p>
      </ScrollAnimation>

      {loading && (
        <ScrollAnimation animateIn="fadeInUp" delay={0.3 * 1000}>
          <p>Loading server status...</p>
        </ScrollAnimation>
      )}

      {!loading && !serverData?.online && (
        <ScrollAnimation animateIn="fadeInUp" delay={0.3 * 1000}>
          <div className="server-info">
            <div className="detail-item">
              <span>Status</span>
              <div className="status-display">
                <span className="status-indicator offline"></span>
                <strong>Offline</strong>
              </div>
            </div>
          </div>
        </ScrollAnimation>
      )}

      {!loading && serverData?.online && (
        <ScrollAnimation animateIn="fadeInUp" delay={0.3 * 1000}>
          <div className="server-info">
            
            <div className="motd-container">
              {serverData.icon && (
                <img src={serverData.icon} alt="Server Icon" className="server-icon" />
              )}
              {renderMotd()}
            </div>

            <div className="details-grid">
              {/* Baris 1: Status & Players */}
              <div className="detail-item">
                <span>Status</span>
                <div className="status-display">
                  <span className="status-indicator online"></span>
                  <strong>Online</strong>
                </div>
              </div>
              <div className="detail-item">
                <span>Players</span>
                <strong>
                  {serverData.players?.online || 0} / {serverData.players?.max || 0}
                </strong>
              </div>

              {/* Baris 2: Version & Dynmap */}
              <div className="detail-item">
                <span>Version</span>
                <strong>{serverData.version?.name_clean || 'N/A'}</strong>
              </div>
              <div className="detail-item">
                <span>Dynmap</span>
                <a
                  href={dynmapUrl}
                  rel="noreferrer"
                  className="map-link-button"
                >
                  Open Map
                </a>
              </div>

              {/* Baris 3: Java IP & Bedrock IP */}
              <div className="detail-item">
                <span>Server IP (Java)</span>
                <button
                  className={`copy-button ${javaCopied ? 'copied' : ''}`}
                  onClick={copyJavaToClipboard}
                >
                  {javaCopied ? 'Copied!' : javaIp}
                </button>
              </div>
              <div className="detail-item">
                <span>Server IP (Bedrock)</span>
                <button
                  className={`copy-button ${bedrockCopied ? 'copied' : ''}`}
                  onClick={copyBedrockToClipboard}
                >
                  {bedrockCopied ? 'Copied!' : bedrockIp}
                </button>
              </div>
            </div>

            {/* --- SEKSI BARU ANDA DIMULAI DI SINI --- */}
            <div className="optional-links">
              <h4>Optional Requirements (Enhanced For Java Only)</h4>
              <div className="links-grid">
                
                {/* --- PERUBAHAN DI SINI (Workaround) --- */}
                {/* target="_blank" dan rel="noreferrer" DIHAPUS */}
                <a
                  href={installerUrl}
                  className="link-button installer"
                >
                  Download Installer
                </a>
                <a
                  href={tutorialUrl}
                  className="link-button tutorial"
                >
                  View Tutorial
                </a>
                {/* --- AKHIR PERUBAHAN --- */}

              </div>
            </div>
            {/* --- SEKSI BARU ANDA BERAKHIR DI SINI --- */}

          </div>
        </ScrollAnimation>
      )}
    </Container>
  )
}